require("./config")
  .initialize()
  .then(() => {
    require("./index");
  })
  .catch((err) => {
    console.log(err);
    alert("Not able to fetch config.json");
  });
